import React, { memo } from 'react';
import { View, Text } from 'react-native';

import { useDispatch, useSelector } from 'react-redux';
import Summary from '../airforce/summary/main';
import Patients from '../cases/airforce/lookup';
import Reports from '../reports/airforce/base_reports';
import Consults from '../referrals/main';
import OnCall from '../airforce/staff_rotation/oncall';
import Scheduling from '../airforce/scheduler/pha_admin';
import Staff from '../staff/main';
import PHA from '../pha/main';

import GreetingHeader from '../employer/greeting_header';

const ROUTES = {
  Summary,
  Patients,
  Reports,
  Consults,
  OnCall,
  Scheduling,
  Staff,
  PHA,
};

const MilHome = memo(function MilHome(props) {
  console.info('>>> route is', props.screen);
  const Comp = ROUTES[props.screen];

  return (
    <View style={{ flex: 1 }}>
      <GreetingHeader />
      <View style={{ flex: 1 }}>{Comp && <Comp {...props} />}</View>
    </View>
  );
});

export default MilHome;
